import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { currencyFormat } from '../../../../../../../utils/Helper'
import { SharedCampaignContext } from '../../../../../../../contexts/Advertiser/SharedCampaignContext'

export default observer(function NonMediaAction({ action }) {
  const { campaign } = useContext(SharedCampaignContext)

  return (
    <tr className="dark:border-b dark:border-rb-dark-mode-lighter">
      <td className="p-2 text-xs align-middle font-bold dark:text-white">
        <p>{action.name}</p>
      </td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserPrice.toFixed(2), campaign.currency_symbol)}</td>
    </tr>
  )
})